import {Component, computed, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {AdminCategoryStore} from "@features/admin";

@Component({
  selector: 'app-admin-categories',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DragDropModule],
  templateUrl: 'admin-categories.component.html',
  styleUrl: 'admin-categories.component.scss'
})
export class AdminCategoriesComponent implements OnInit {
  readonly store = inject(AdminCategoryStore);
  searchTerm = '';
  restaurantFilter = '';
  statusFilter = '';
  showModal = signal(false);
  editingCategory = signal<any>(null);
  filteredCategories = computed(() => {
    let categories = this.store.categories();

    if (this.searchTerm) {
      const term = this.searchTerm.toLowerCase();
      categories = categories.filter(c =>
        c.name.toLowerCase().includes(term) ||
        c.description?.toLowerCase().includes(term)
      );
    }

    if (this.restaurantFilter) {
      categories = categories.filter(c =>
        c.restaurantId === Number(this.restaurantFilter)
      );
    }

    if (this.statusFilter) {
      const isActive = this.statusFilter === 'active';
      categories = categories.filter(c => c.active === isActive);
    }

    return categories.sort((a, b) => a.displayOrder - b.displayOrder);
  });
  private readonly fb = inject(FormBuilder);
  categoryForm: FormGroup = this.fb.group({
    restaurantId: ['', Validators.required],
    name: ['', [Validators.required, Validators.minLength(2)]],
    description: [''],
    icon: ['fas fa-utensils'],
    color: ['#10b981'],
    displayOrder: [0],
    active: [true]
  });

  ngOnInit(): void {
    this.store.loadCategories();
    this.store.loadRestaurants();
  }

  onSearch(term: string): void {
    // Filtrage géré par le computed signal
  }

  onFilterChange(): void {
    // Filtrage géré par le computed signal
  }

  openCreateModal(): void {
    this.editingCategory.set(null);
    this.categoryForm.reset({
      icon: 'fas fa-utensils',
      color: '#10b981',
      displayOrder: 0,
      active: true
    });
    this.showModal.set(true);
  }

  editCategory(category: any): void {
    this.editingCategory.set(category);
    this.categoryForm.patchValue({
      restaurantId: category.restaurantId,
      name: category.name,
      description: category.description || '',
      icon: category.icon || 'fas fa-utensils',
      color: category.color || '#10b981',
      displayOrder: category.displayOrder,
      active: category.active
    });
    this.showModal.set(true);
  }

  closeModal(): void {
    this.showModal.set(false);
    this.editingCategory.set(null);
  }

  saveCategory(): void {
    if (this.categoryForm.valid) {
      const formValue = this.categoryForm.value;

      if (this.editingCategory()) {
        this.store.updateCategory({
          id: this.editingCategory().id,
          ...formValue
        });
      } else {
        this.store.createCategory(formValue);
      }

      this.closeModal();
    }
  }

  deleteCategory(category: any): void {
    if (confirm(`Êtes-vous sûr de vouloir supprimer la catégorie "${category.name}" ?`)) {
      this.store.deleteCategory(category.id);
    }
  }

  toggleCategoryStatus(category: any): void {
    this.store.updateCategory({
      ...category,
      active: !category.active
    });
  }
}

